<div class="modal fade" id="ocorrendiaPedagioModal" tabindex="-1" aria-labelledby="ocorrendiaPedagioModal" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">  
      <div class="modal-header justify-content-between">
        <button id="btnOcorrendiaPedagio"  (click)="criarFormulario()" hidden=true> </button>
        <h5 class="modal-title" > Gerar ocorrência pedágio</h5>
        <button id="ocorrendiaPedagioModal" style="display: none"></button>
        <img data-bs-dismiss="modal" class='bt-fechar' src="assets/img/icon_bt-limpar_header.svg">
      </div>

      <div class="modal-body">
        <form (ngSubmit)="onSubmit()">   
          
          <div class="d-flex justify-content-center mt-3 ">
            <span class="title">Confirma criação de ocorrência referente a praça {{ praca }}</span>
          </div>

          <div class="modal-footer d-flex justify-content-around">
            <button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary btn-sm" [disabled]="loading">Criar</button>
          </div>
                    
        </form>
      </div>  
    </div>
  </div>
</div>